import axiosInstance from "./AxiosInstance";
import indexedDBService from './IndexedDBService';

export function getOrders(page) {
  return axiosInstance.get('/api/orderings', {params: {page: page}});
}

export function getOrder(id, token, isTerminal) {
  return axiosInstance.get(`/api/orderings/${id}`, { params: {share_token: token, is_terminal: isTerminal} });
}

export function getGroupOrders(id) {
  return axiosInstance.get(`/api/orderings/${id}/group_orders`);
}

export function getDeliveryPrice(params) {
  return axiosInstance.get(`/api/calculate_delivery_price`, { params: params });
}

// export function getPackingPrice(params) {
//   const userDetails = JSON.parse(localStorage.getItem('userDetails'));
//   let config = null;
//   if (!!userDetails && !!userDetails.idToken) {
//     config = {
//       headers: {
//         'access-token': userDetails.idToken,
//         client: userDetails.client,
//         uid: userDetails.uid,
//       },
//       params: params
//     };
//   } else {
//     config = { params: params };
//   }
//   return axios.get(`${process.env.REACT_APP_API_URL}/api/calculate_packing_price`, config);
// }

export function makeOrder(restaurant_id, dishes, params, payMethod) {
  const payShares = !!params.payShares && params.payShares.map((ps) => {
    const dishes = Object.values(ps.dishes).map((d) => {
      if (!!d.selectedVariation) {
        return {id: d.id, quantity: d.quantity, dish_variation_id: d.selectedVariation.id}
      } else {
        return {id: d.id, quantity: d.quantity}
      }
    });
    return {amount: ps.amount, dishes: dishes, name: ps.name}
  });
  const orders = [];
  const sales = [];
  dishes.forEach((dish) => {
    if (dish.is_sale) {
      sales.push({ id: dish.id, quantity: dish.quantity });
    } else {
      const mods = Object.values(!!dish.selectedMods ? dish.selectedMods : {});
      if (!!dish.selectedVariation) {
        orders.push({id: dish.id, quantity: dish.quantity, dish_variation_id: dish.selectedVariation.id, mods: mods});
      } else {
        orders.push({id: dish.id, quantity: dish.quantity, mods: mods});
      }
    }
  });
  const tableId = params.selectedOrderType === 'on_table' ? params.table_id :
    (params.selectedOrderType === 'to_visit' && params.addTableToOrder ? params.selectedTable.id : null);
  const postData = { restaurant_id, orders: orders, sales: sales, order_type: params.selectedOrderType,
    payment_type: payMethod || params.selectedPaymentType, time: new Date(params.time).getTime()/1000,
    description: params.description, when_ready: params.selectedReadyType === 'when_ready',
    persons: params.selectedOrderType === 'to_visit' ? params.persons : null,
    table_id: tableId,
    first_name: params.first_name,
    last_name: params.last_name,
    email: params.email,
    telegram_id: params.telegram_id,
    apple_id: params.apple_id,
    phone: params.phone,
    cutleries: params.cutleries,
    shared: params.shareOrder,
    from_terminal: params.from_terminal,
    after_pay_method: params.after_pay_method || 'no_method',
    to_door: params.selectedDeliveryType === 'door',
    entrance: params.entrance,
    floor: params.floor,
    apartment: params.apartment,
    intercom: params.intercom
  };
  if (params.selectedOrderType === 'delivery') {
    Object.assign(postData, {delivery_point: params.delivery_point, delivery_address: params.delivery_address})
  }
  if (params.shareOrder) {
    Object.assign(postData, {pay_shares: payShares})
  }
  if (!!params.qr_id) {
    Object.assign(postData, {qr_id: params.qr_id})
  }
  if (!!params.theme) {
    Object.assign(postData, {theme: params.theme})
  }
  return axiosInstance.post(`/api/orderings`, postData);
}

export function makeBulkOrder(dishes, params) {
  let orders = {};
  let sales = {};
  Object.keys(dishes).forEach((rId) => {
    orders[rId] = [];
    sales[rId] = [];
    (dishes[rId] || []).forEach((d) => {
      if (d.is_sale) {
        sales[rId].push({ id: d.id, quantity: d.quantity });
      } else {
        const mods = Object.values(!!d.selectedMods ? d.selectedMods : {});
        if (!!d.selectedVariation) {
          orders[rId].push({ id: d.id, quantity: d.quantity, dish_variation_id: d.selectedVariation.id, mods: mods });
        } else {
          orders[rId].push({ id: d.id, quantity: d.quantity, mods: mods });
        }
      }
    });
  });
  const tableId = params.selectedOrderType === 'on_table' ? params.table_id :
    (params.selectedOrderType === 'to_visit' && params.addTableToOrder ? params.selectedTable.id : null);
  const postData = { orders: orders, sales: sales, order_type: params.selectedOrderType,
    payment_type: params.selectedPaymentType, time: new Date(params.time).getTime()/1000,
    description: params.description, when_ready: params.selectedReadyType === 'when_ready',
    persons: params.selectedOrderType !== 'to_go' ? params.persons : null,
    table_id: tableId,
    first_name: params.first_name,
    phone: params.phone,
    after_pay_method: params.after_pay_method || 'no_method',
    parent_restaurant_id: params.parent_restaurant_id,
    to_door: params.selectedDeliveryType === 'door',
    entrance: params.entrance,
    floor: params.floor,
    apartment: params.apartment,
    intercom: params.intercom
  };
  if (!!params.qr_id) {
    Object.assign(postData, {qr_id: params.qr_id})
  }
  if (!!params.theme) {
    Object.assign(postData, {theme: params.theme})
  }
  if (params.selectedOrderType === 'delivery') {
    Object.assign(postData, {delivery_point: params.delivery_point, delivery_address: params.delivery_address})
  }
  return axiosInstance.post(`/api/orderings/bulk_create`, postData);
}

export function payPayCheck(restaurant, payCheck) {
  const postData = { restaurant_id: restaurant.id, pay_check_id: payCheck.id, table_id: restaurant.table.id};
  return axiosInstance.post(`/api/payments`, postData);
}

export function checkInvoiceStatus(id) {
  return axiosInstance.get(`/api/payments/order_status`, {params: {order_id: id}});
}

export function checkPayShareInvoiceStatus(order, payShare) {
  return axiosInstance.get(`/api/payments/pay_share_status`,
    { params: {pay_share_id: payShare.id, order_id: order.id}});
}

export function updateOrder(parameters, order) {
  return axiosInstance.put(`/api/orderings/${order.id}`, {ordering: parameters});
}

export function refundOrder(order) {
  return axiosInstance.put(`/api/orderings/${order.id}/refund`);
}

export function cancelOrder(order, is_terminal) {
  return axiosInstance.delete(`/api/orderings/${order.id}`, {params: {is_terminal, share_token: order.share_token}});
}

export function cancelBulkOrder(ids) {
  return axiosInstance.delete(`/api/orderings/bulk_cancel?ids=[${ids}]`);
}

export function printCheckboxReceipt(id, params) {
  return axiosInstance.post(`/api/orderings/${id}/print_checkbox`, params);
}

export function updateOrderMessage(order) {
  return axiosInstance.put(`/api/order_messages/${order}`,);
}

export function getActiveOrders() {
  return axiosInstance.get(`/api/orderings/active_orders`);
}

export function sendOrderTerminal(dishes, slug, tableId, phone) {
  const params = {dishes: dishes, slug: slug, phone: phone};
  return axiosInstance.post(`/api/orderings/${tableId}/send_order_to_terminal`, params);
}

export function saveOrderDishesToLocalStorage(restaurant) {
  return indexedDBService.getOrderData('checkoutDishes').then(old => {
    const updatedData = Object.assign(old || {},
      {[restaurant.restaurant.slug]: {restaurant: restaurant.restaurant, dishes: restaurant.dishes, company: restaurant.company}}
    );
    return indexedDBService.setOrderData('checkoutDishes', updatedData);
  });
}

export function removeDishesFromLocalStorage(slug) {
  return indexedDBService.getOrderData('checkoutDishes').then(old => {
    if (old) {
    delete old[slug];
      return indexedDBService.setOrderData('checkoutDishes', old);
  }
  });
}

export function removeCategoryDishesFromLocalStorage(slug, dishes) {
  return indexedDBService.getOrderData('checkoutDishes').then(old => {
    if (old && old[slug]) {
    old[slug].dishes = dishes;
      return indexedDBService.setOrderData('checkoutDishes', old);
  }
  });
}